import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 ,  error: "", message: "" }


export const getAllLifeLineAction = createAsyncThunk(
    'get-all-lifeline',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-all-lifeline`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAllLifeLineSlice = createSlice({
    name: 'get-all-lifeline',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllLifeLineAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllLifeLineAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.count
            })
            builder.addCase(getAllLifeLineAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getAllLifeLineSliceReducer = getAllLifeLineSlice.reducer    